<template>
  <div>
    <div class="background"></div>
    <div class="personal-page-container">
      <div class="edit-info">
        <template v-if="logged">
          <router-link :to="{ name: 'userEditor' }">
            <span>编辑资料</span>
          </router-link>
          <img src="../../assets/personal/editor@2x.png" alt="" />
        </template>
      </div>

      <img
        class="avatar"
        :src="avatar === null ? defaultAvatar : avatar"
        alt=""
      />

      <div v-if="logged" class="logged">
        <div class="info" v-if="isVip">
          <img src="../../assets/personal/vip@2x.png" alt="" />
          <p>{{ vipName }}用户（剩余{{ vipDay }}天）</p>
        </div>
        <div class="info" v-else>
          <p>{{ nickname }}</p>
        </div>
        <p>ID:{{ id }}</p>
      </div>
      <div v-else class="login-button" @click="$router.push({ name: 'login' })">
        登录
      </div>

      <div class="bar-container">
        <ul class="bar">
          <li>
            <div class="icon-wrapper">
              <img src="../../assets/personal/horizontal_1@2x.png" alt="" />
              <p v-if="isVip" class="watch-number">
                无限次
              </p>
              <p v-else class="watch-number">
                <span>{{ count }}</span
                >/<span>{{ totalCount }}</span>
              </p>
            </div>
            <p>每日观看次数</p>
          </li>
          <li>
            <router-link :to="{ name: 'vip' }">
              <div class="icon-wrapper">
                <img src="../../assets/personal/horizontal_2@2x.png" alt="" />
              </div>
              <p>开通VIP会员</p>
            </router-link>
          </li>
          <li @click="openPopup">
            <div class="icon-wrapper">
              <img src="../../assets/personal/horizontal_3@2x.png" alt="" />
            </div>
            <p>火爆交流群</p>
          </li>
          <li>
            <router-link :to="{ name: 'invite' }">
              <div class="icon-wrapper">
                <img src="../../assets/personal/horizontal_4@2x.png" alt="" />
              </div>
              <p>邀请好友</p>
            </router-link>
          </li>
        </ul>
      </div>

      <ul class="function-container">
        <li
          v-for="myFunction in myFunctions"
          :key="myFunction.name"
          @click="navigateTo(myFunction)"
        >
          <div class="left">
            <img class="icon" :src="myFunction.icon" alt="" />
            <span>{{ myFunction.name }}</span>
          </div>
          <img class="right" src="../../assets/personal/right@2x.png" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getCurrentTime } from "@/utils/watchVideoNum";
import { mapState, mapGetters } from "vuex";
import { getWatchTimes } from "@/api/video";
import defaultAvatar from "@/assets/personal/default_avatar@2x.png";

import icon1 from "@/assets/personal/vertical_1@2x.png";
import icon2 from "@/assets/personal/vertical_2@2x.png";
import icon3 from "@/assets/personal/vertical_3@2x.png";
import icon4 from "@/assets/personal/vertical_4@2x.png";
import icon5 from "@/assets/personal/vertical_5@2x.png";
import { getGroups } from "@/api/group";

export default {
  name: "Personal",
  data() {
    return {
      defaultAvatar,
      myFunctions: [
        {
          icon: icon1,
          name: "我的关注",
          routeName: "myAttention"
        },
        {
          icon: icon2,
          name: "观看记录",
          routeName: "watchHistory"
        },
        {
          icon: icon3,
          name: "我的订单",
          routeName: "order"
        },
        {
          icon: icon4,
          name: "在线客服",
          routeName: "chat"
        },
        {
          icon: icon5,
          name: "设置",
          routeName: "setting"
        }
      ],
      groupUrl: "",
      count: null,
      totalCount: null
    };
  },
  computed: {
    ...mapState("user", ["avatar", "id", "nickname", "vipName", "vipDay"]),
    ...mapState("platform", ["serviceId"]),
    ...mapGetters("user", ["logged", "isVip"]),
    getVipDays() {
      return getCurrentTime();
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { count, totalCount } = await getWatchTimes();
      this.count = count;
      this.totalCount = totalCount;
      const { url } = await getGroups();
      this.groupUrl = url;
    },
    navigateTo({ routeName }) {
      if (routeName === "chat") {
        this.$router.push({
          name: routeName,
          params: {
            id: this.serviceId
          }
        });
      } else {
        this.$router.push({
          name: routeName
        });
      }
    },
    openPopup() {
      window.open(this.groupUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.background {
  position: absolute;
  background: rgba(245, 245, 248, 1);
  width: 100%;
  height: 100vh;
  z-index: -1;
}
.personal-page-container {
  padding: 23px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-image: url("../../assets/personal/bg@2x.png");
  background-size: 100% 277px;
  background-repeat: no-repeat;
  .edit-info {
    display: flex;
    justify-content: flex-end;
    margin-right: 15px;
    height: 21px;
    align-self: flex-end;
    img {
      margin-left: 8px;
      width: 18px;
      height: 18px;
    }
    span {
      font-size: 15px;
      line-height: 21px;
      font-weight: 500;
    }
  }
  .avatar {
    margin-top: 10px;
    width: 75px;
    height: 75px;
    border-radius: 50%;
  }
  .logged {
    display: flex;
    flex-direction: column;
    padding-bottom: 11px;
    .info {
      margin-top: 20px;
      display: flex;
      align-items: center;
      img {
        margin-right: 6px;
        width: 16px;
        height: 17px;
      }
      p {
        margin: auto;
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 22px;
      }
    }
    p {
      margin-top: 5px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
    }
  }
  .login-button {
    margin: 24px 0 20px 0;
    width: 104px;
    height: 34px;
    border-radius: 28px;
    border: 1px solid rgba(51, 51, 51, 1);
    font-size: 15px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 34px;
  }
  .bar-container {
    padding: 0 15px;
    width: 100%;
    .bar {
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 92px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      li {
        .icon-wrapper {
          position: relative;
          margin-bottom: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          .watch-number {
            position: absolute;
            color: #fff;
            font-size: 10px;
            span:nth-child(1) {
              font-size: 14px;
            }
            span:nth-child(2) {
              font-size: 12px;
            }
          }
          img {
            width: 42px;
            height: 42px;
          }
        }
        p {
          height: 17px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          line-height: 17px;
        }
      }
    }
  }

  .function-container {
    margin-top: 11px;
    padding: 5px 0 0 20px;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    width: 100%;
    background: #fff;
    li {
      padding: 10px 0;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        .icon {
          margin-right: 10px;
          width: 30px;
          height: 30px;
        }
      }
      .right {
        margin-right: 19px;
        width: 9px;
        height: 15px;
      }
    }
  }
}
</style>
